import { apiHelpers } from './api';
import { FirePreventionInstructionItem, ApiResponse, FirePreventionInstructionItemFormData, FirePreventionInstructionItemList } from '../types/models';
import { convertToUtcDate } from '../utils/dateUtils';

export class FirePreventionInstructionItemService {
  // Получить все противопожарные инструктажи (упрощенная версия для списка)
  static async getAll(companyId?: number): Promise<ApiResponse<FirePreventionInstructionItemList[]>> {
    const url = companyId ? `/FirePreventionInstructionItem/GetAll?companyId=${companyId}` : `/FirePreventionInstructionItem/GetAll`;
    return apiHelpers.get<FirePreventionInstructionItemList[]>(url);
  }

  // Получить противопожарный инструктаж по ID
  static async getById(id: number): Promise<ApiResponse<FirePreventionInstructionItem>> {
    return apiHelpers.get<FirePreventionInstructionItem>(`/FirePreventionInstructionItem/Get?id=${id}`);
  }

  // Получить противопожарные инструктажи по сотруднику (упрощенная версия для списка)
  static async getByEmployee(employeeId: number): Promise<ApiResponse<FirePreventionInstructionItemList[]>> {
    return apiHelpers.get<FirePreventionInstructionItemList[]>(`/FirePreventionInstructionItem/GetByEmployee?employeeId=${employeeId}`);
  }

  // Создать новый противопожарный инструктаж
  static async create(data: FirePreventionInstructionItemFormData): Promise<ApiResponse<FirePreventionInstructionItem>> {
    const utcData = {
      ...data,
      date: convertToUtcDate(data.date),
    };
    return apiHelpers.post<FirePreventionInstructionItem>('/FirePreventionInstructionItem/Create', utcData);
  }

  // Обновить противопожарный инструктаж
  static async update(id: number, data: FirePreventionInstructionItemFormData & { id: number }): Promise<ApiResponse<void>> {
    const utcData = {
      ...data,
      date: convertToUtcDate(data.date),
    };
    return apiHelpers.put<void>(`/FirePreventionInstructionItem/Update/${id}`, utcData);
  }

  // Удалить противопожарный инструктаж
  static async delete(id: number): Promise<ApiResponse<void>> {
    return apiHelpers.delete<void>(`/FirePreventionInstructionItem/Delete/${id}`);
  }
}